import { Component, OnInit } from '@angular/core';
import { AccountService } from 'src/app/core/services/auth/account.service';
import { AuthService } from 'src/app/core/services/auth/auth.service';

@Component({
  selector: 'app-main-page',
  templateUrl: './main-page.component.html',
  styleUrls: ['./main-page.component.scss']
})
export class MainPageComponent implements OnInit {

  constructor(private accountService:AccountService,
    private authService: AuthService,) { }

  ngOnInit(): void {
    
    this.loadUserProfile();
  }
  async loadUserProfile() {  
    if(this.authService.getUser().firstName != ''){
      await this.accountService.loadUserProfile();
    }
  }

}
